import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';
@Injectable({
	providedIn: 'root'
})
export class GroupiRouteService {
	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }

	getRouteData(kpiId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gisummary/${kpiId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	getRouteComments(kpiId, alarmID, periodid): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/gisummary/commentSummary/${periodid}/${kpiId}/${alarmID}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError)
			);
	}

	markRouteAsComplete(compOrReArr) {
		return this.http.put(`${this.constantsService.baseAPIURL}/gisummary/completeReopen`, compOrReArr, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				// tap(_ => this.log('data success')),
				catchError(this.handleError)
			);
	}

	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}


}